'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlWaitFor", function ($animate) {
  return {
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function link($scope, $element, $attr, ctrl, $transclude) {
      var unwatchWaitFor = $scope.$watch($attr.tlWaitFor, function tlWaitForWatchAction(value) {
        if (value) {
          var childScope = $scope.$new();
          $transclude(childScope, function (clone) {
            $animate.enter(clone, $element.parent(), $element);
          });
          unwatchWaitFor();
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlWaitFor.js
// module id = 2911
// module chunks = 13